<template>
  <div class="element-input element-textarea" :class="{ disabled }">
    <div class="label">{{ label }}</div>
    <div class="body">
      <textarea v-model="model" :disabled="disabled" :placeholder="placeholder" />
    </div>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "disabled", "placeholder" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    }
  }

}
</script>
